import { OnInit } from '@angular/core';
import { PropertySearchService } from './property-search.service';
import { GlobalService } from '../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import { PropertySearchResultsComponent } from './property-search-results/property-search-results.component';
function cleanupSearchParams(scrit) {
    var params = {}, val;
    for (var key in scrit) {
        val = scrit[key];
        if (val !== null && val.length > 0)
            params[key] = val;
    }
    return params;
}
var PropertySearchComponent = /** @class */ (function () {
    function PropertySearchComponent(_searchSvc, _globalSvc) {
        var _this = this;
        this._searchSvc = _searchSvc;
        this._globalSvc = _globalSvc;
        this.paginate = false;
        this.lazyLoad = false;
        this.autoSearch = false;
        /* show the search form */
        this.showform = false;
        /* default page size */
        this.rows = 10;
        this.api = _GlobalNS.api.property.search;
        /* private properties */
        this._properties = [];
        /* public properties */
        this.properties = [];
        this.searchParams = {};
        this.searchCriteria = {};
        this.loadData = function (event) {
            _this.searchCriteria = _this._globalSvc.find(_this.autosearchCriteriaPath);
            _this.searchParams = cleanupSearchParams(_this.searchCriteria);
            _this.searchParams.Offset = event.first;
            _this.searchParams.PageSize = event.rows;
            _this._searchSvc
                .search(_this.api, _this.searchParams)
                .subscribe(function (res) {
                _this._properties = res.data;
                _this.properties = _this._properties;
                _this.resultsComponent.loading = false;
                // update property search results component
                _this.resultsComponent.pagination = res.meta.pagination;
                _this.resultsComponent.totalRecords = res.meta.pagination.TotalRecords;
                _this.resultsComponent.searchCriteria = _this.searchParams;
            });
        };
    }
    Object.defineProperty(PropertySearchComponent.prototype, "value", {
        get: function () { return this._properties; },
        set: function (val) { this._properties = val; },
        enumerable: true,
        configurable: true
    });
    PropertySearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log("PropertySearch Component::INITED", this.autosearchCriteriaPath);
        /**
         * check attributes
         * These just need to exist to be considered true
         */
        // if(this.paginate    !== undefined) this.paginate = true;
        // if(this.lazyload    !== undefined) this.lazyload = true;
        // if(this.autosearch  !== undefined) this.autosearch = true;
        console.log("Attributes: ", this.paginate, this.lazyLoad, this.autoSearch, this.autosearchCriteriaPath);
        /**
         * autosearch triggers search on page load
         */
        if (this.autoSearch) {
            this.searchCriteria = this._globalSvc.find(this.autosearchCriteriaPath);
            /* remove any nulls */
            if (this.autosearchCriteriaPath) {
                this.searchParams = cleanupSearchParams(this.searchCriteria);
            }
            console.log("Autosearching", this.api, this.searchParams);
            this.resultsComponent.loading = true;
            this._searchSvc
                .search(this.api, this.searchParams)
                .subscribe(function (res) {
                _this._properties = res.data;
                _this.properties = _this._properties;
                _this.resultsComponent.loading = false;
                // this.resultsComponent.properties = this._properties;
                // update property search results component
                _this.resultsComponent.pagination = res.meta.pagination;
                _this.resultsComponent.totalRecords = res.meta.pagination.TotalRecords;
                _this.resultsComponent.searchCriteria = _this.searchParams;
            });
        }
    };
    return PropertySearchComponent;
}());
export { PropertySearchComponent };
